import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from '../services/auth.service'

/**
 * Redirects COACH role users from /home to /my-teams.
 * Non-COACH roles pass through unaffected.
 */
export const coachRedirectGuard: CanActivateFn = () => {
  const authService = inject(AuthService)
  const router = inject(Router)

  if (authService.isCoach()) {
    return router.createUrlTree(['/my-teams'])
  }

  return true
}
